import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './GreetingUser.css';
import { getLoy3Profile } from "../../selectors/authentication";

class GreetingUser extends React.Component {
  render() {
    const { loy3Profile } = this.props;
    const { t } = this.context;

    return (
      <div className="greeting-container">
        <h2 className="greeting-title">
          {t('Hi')}, {loy3Profile && loy3Profile.firstName}!
        </h2>
        <p className="greeting-email">
          {loy3Profile && loy3Profile.userName}
        </p>
      </div>
    );
  }
}

GreetingUser.propTypes = {
  loy3Profile: PropTypes.object,
};

GreetingUser.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loy3Profile: getLoy3Profile(state),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GreetingUser);
